<template>
  <div class="login">
    <v-content>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5">
            <v-card class="pb-5">
              <v-toolbar flat color="primary" dark>
                <div class="d-flex justify-center w-100">
                <v-toolbar-title class="text-h5">{{ $t("login.header") }}</v-toolbar-title>
              </div>
              </v-toolbar>
              <v-card-text class="px-4 pt-5 justify-center text-center">
                <v-form @submit="onSubmit">
                  <v-text-field
                    v-if="$i18n.locale=='tc'"
                    v-model="form.username"
                    label="登入名稱"
                    prepend-icon="mdi-account"
                    outlined
                    dense
                    required 
                    light="light"
                  />
                  <v-text-field
                    v-else
                    v-model="form.username"
                    label="Username"
                    prepend-icon="mdi-account"
                    outlined
                    dense
                    required 
                    light="light"
                  />
                  <v-text-field
                    v-if="$i18n.locale=='tc'"
                    v-model="form.password"
                    label="密碼"
                    prepend-icon="mdi-lock"
                    outlined
                    dense
                    required
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  />
                  <v-text-field
                    v-else
                    v-model="form.password"
                    label="Password"
                    prepend-icon="mdi-lock"
                    outlined
                    dense
                    required
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  />
                  <v-btn v-if="$i18n.locale=='tc'" color="primary" class="px-8 py-4" dense dark  type="submit">
                    登入
                  </v-btn>
                  <v-btn v-else color="primary" class="px-8 py-4" dense dark  type="submit">
                    Login
                  </v-btn>
                </v-form>
              </v-card-text>
              <hr class="mx-4"></hr>
              <v-card-actions class="justify-center">
                <div v-if="$i18n.locale=='tc'">
                  <v-img :style="{ cursor: 'default', opacity: 0.5 }" src="@/assets/EdConnect Login Button_Chi.png" max-width="250"></v-img>
                  <div class="text-center">(稍後推出)</div>
                </div>
                <div v-else>
                  <v-img :style="{ cursor: 'default', opacity: 0.5 }" src="@/assets/EdConnect Login Button_Eng.png" max-width="250"></v-img>
                  <div class="text-center">(Coming Soon)</div>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
    </v-content>
  </div>
</template>
<script>
import moment from "moment";
import { Auth_APIService } from "@/services/Auth_APIService";
const apiService = new Auth_APIService(
  process.env.VUE_APP_BASE_URL + "/api/auth/"
);
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._backRoute = from.path
    })
  },
  name: "login",
  components: {},
  data: function () {
    return {
      form: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
      },
      options: {
        isLoggingIn: true,
      },
      showPassword: false,
    };
  },
  mounted: function () {
    var self = this;
    if(self.$cookies.get("auth_token")!="" && self.$cookies.get("auth_token")!=undefined && self.$cookies.get("auth_token")!=null){
      self.$router.push("/announcement");
    }
  },
  methods: {
    onSubmit(evt) {
      var self = this;
      evt.preventDefault();
      self.overlay = true;
      if (self.options.isLoggingIn) {
        //login
        apiService
          .login(self.form.username, self.form.password)
          .then((response) => {
            if (response.status == "fail") {
              self.$store.commit("showSnackBar", response.message);
            } else {
              self.$cookies.set("auth_token", response.token);
              self.$cookies.set("username", response.username);
              self.$cookies.set("user_level", response.user_level);
              self.$cookies.set("school_id", response.school_id);
              self.$cookies.set("school_name", response.school_name);
              self.$cookies.set("school_chi_name", response.school_chi_name);
              let username = response.username;
              let user_level = response.user_level;
              let school_id = response.school_id;
              let school_name = response.school_name;              
              let school_chi_name = response.school_chi_name;
              let auth_token = response.token;
              let admin = false;
              let logged_in = true;
              if(user_level == "ADMIN") admin = true;
              self.$store.state.current.username = response.username;
              self.$store.state.current.user_level = response.user_level;
              self.$store.state.current.logged_in = true;
              self.$store.commit("updateUserInfo", {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token});
              self.$store.commit("showSnackBar", "Login Success");
              console.log(self._backRoute);
              if(self._backRoute == "/login" || self._backRoute == undefined || self._backRoute == "/" || self._backRoute == "/logout"){
                self.$router.go("/announcement");
                
              }
              else {
                self.$router.go(-1);
              }
            }
          });
      } else {
        //register
        apiService
          .register(
            self.form.username,
            self.form.email,
            self.form.password,
            self.form.confirm_password
          )
          .then((response) => {
            console.log("response");
            console.log(response);
            if (response.status == "fail") {
              alert(response.message);
            } else {
              self.$store.commit(
                "showSnackBar",
                "Register Success! You can login now."
              );
              self.options.isLoggingIn = true;
            }
          });
      }
    },
    redirect(url){
      window.location.href = url;
    }
  },  
};
</script>
<style>
.login-form {
  width: 500px;
}
</style>